import React from 'react';

interface AnimationControlsProps {
  currentStep: number;
  totalSteps: number;
  isPlaying: boolean;
  speed: number;
  stepDescription: string;
  onPlayPause: () => void;
  onStepBack: () => void;
  onStepForward: () => void;
  onSpeedChange: (speed: number) => void;
}

export const AnimationControls: React.FC<AnimationControlsProps> = ({
  currentStep,
  totalSteps,
  isPlaying,
  speed,
  stepDescription,
  onPlayPause,
  onStepBack,
  onStepForward,
  onSpeedChange,
}) => {
  return (
    <div className="animation-controls">
      <div className="animation-controls-row">
        <div className="animation-controls-buttons">
          <button
            onClick={onStepBack}
            disabled={currentStep === 0}
            className="btn btn-sm btn-outline-neutral"
            title="Previous step"
            aria-label="Previous step"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="19 20 9 12 19 4 19 20" />
              <line x1="5" y1="19" x2="5" y2="5" />
            </svg>
          </button>

          <button
            onClick={onPlayPause}
            className="btn btn-sm btn-primary"
            title={isPlaying ? 'Pause' : 'Play'}
            aria-label={isPlaying ? 'Pause animation' : 'Play animation'}
          >
            {isPlaying ? (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="6" y="4" width="4" height="16" />
                <rect x="14" y="4" width="4" height="16" />
              </svg>
            ) : (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="5 3 19 12 5 21 5 3" />
              </svg>
            )}
          </button>

          <button
            onClick={onStepForward}
            disabled={currentStep === totalSteps - 1}
            className="btn btn-sm btn-outline-neutral"
            title="Next step"
            aria-label="Next step"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="5 4 15 12 5 20 5 4" />
              <line x1="19" y1="5" x2="19" y2="19" />
            </svg>
          </button>
        </div>

        <div className="animation-step-indicator">
          Step {currentStep + 1} of {totalSteps}
        </div>

        <div className="animation-speed-selector">
          {[0.5, 1, 2].map((s) => (
            <button
              key={s}
              onClick={() => onSpeedChange(s)}
              className={`btn btn-sm ${speed === s ? 'btn-accent' : 'btn-outline-neutral'}`}
            >
              {s}x
            </button>
          ))}
        </div>
      </div>

      {/* Progress dots */}
      <div className="animation-progress-dots">
        {Array.from({ length: totalSteps }, (_, i) => (
          <div
            key={i}
            className={`animation-progress-dot ${i === currentStep ? 'active' : ''} ${i < currentStep ? 'completed' : ''}`}
          />
        ))}
      </div>

      {/* Step description */}
      <div className="animation-step-description">
        {stepDescription}
      </div>
    </div>
  );
};
